module.exports = __webpack_public_path__ + "img/ic-bancontact.dca8a7dc.svg";